import { AnyAction } from 'redux';

import {
  CUSTOMER_RECEIVED,
  CUSTOMER_RECEIVE_DONE,
  CUSTOMER_RECEIVE_FAILED,
  CUSTOMER_REQUESTED,
  CUSTOMER_UPDATED,
  CUSTOMER_DELETE_REQUESTED,
  CUSTOMER_DELETED,
  CUSTOMER_DELETE_FAILED,
  LOGIN_RECEIVED,
  LOGIN_RECEIVE_DONE,
  LOGIN_RECEIVE_FAILED,
  LOGIN_REQUESTED,
  LOGOUT_RECEIVED,
  LOGOUT_REQUESTED,
} from '@ttstr/actions/customer';
import { Customer } from '@ttstr/api';

export interface ReduxState {
  customer?: Customer;
  error?: Error;
  initialized: boolean;
  loggedIn: boolean;
  loggingIn: boolean;
  loggingOut: boolean;
}

const initialState: ReduxState = {
  customer: null,
  error: null,
  initialized: false,
  loggedIn: false,
  loggingIn: false,
  loggingOut: false,
};

const customer = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case CUSTOMER_REQUESTED:
    case LOGIN_REQUESTED: {
      return {
        ...state,
        loggingIn: true,
        error: null,
      };
    }
    case LOGIN_RECEIVED: {
      return {
        ...state,
        loggedIn: true,
      };
    }
    case CUSTOMER_RECEIVE_DONE:
    case LOGIN_RECEIVE_DONE: {
      return {
        ...state,
        initialized: true,
        loggingIn: false,
      };
    }
    case LOGIN_RECEIVE_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        loggedIn: false,
        error,
      };
    }
    case LOGOUT_REQUESTED:
    case CUSTOMER_DELETE_REQUESTED: {
      return {
        ...state,
        loggingOut: true,
      };
    }
    case LOGOUT_RECEIVED:
    case CUSTOMER_DELETED: {
      return {
        ...state,
        customer: null,
        loggedIn: false,
        loggingOut: false,
      };
    }
    case CUSTOMER_DELETE_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        loggingOut: false,
        error,
      }
    }
    case CUSTOMER_RECEIVED:
    case CUSTOMER_UPDATED: {
      const { customer } = action.payload;
      return {
        ...state,
        loggedIn: true,
        customer,
      };
    }
    case CUSTOMER_RECEIVE_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        loggedIn: false,
        customer: null,
        error,
      };
    }
    default:
      return state;
  }
};

export default customer;
